<template>
<div>
<div class="comment-height">
 <div class="timeline-comment">
  <div class="content"
       v-if="comments.length"
       v-for="comment in commentList"
       v-bind:key="comment._id">
   <div class="content-item">
    <div class="dot" :class="sectionClass[comment.type]"></div>
   </div>
   <div class="content-body">
    <div class="content-body-status">
     <p class="content-item-title"> {{ (comment.user.name) ? comment.user.name : 'User' }} </p>
     <p class="content-item-sec"> {{comment.create_at | moment("DD MMM YY | HH : mm A") }} </p>
     <p class="content-item-primary"> {{comment.message}} </p>
    </div>
   </div>
  </div>

 </div>
</div>
<div v-if="!showForm" class="makeTop" :class="{ 'form-error': $v.comment.$error }">
  <form @submit.prevent="submit">
    <textarea rows="2" v-model.trim="$v.comment.$model"></textarea>
  <div class="error-msg" v-if="!$v.comment.required">
     Comment is required
   </div>
  <div class="error-msg" v-if="!$v.comment.minLength">
     Comment must have at least {{$v.comment.$params.minLength.min}} letters.
   </div>
<br /><br />
   <div class="right-btn">
   <button class="btn btn-primary">
     Submit Comments
   </button>
 </div>
 </form>
</div>
</div>
</template>

<script>
import _ from 'lodash';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      comment: null,
      submitStatus: null,
      sectionClass: ['dot', 'dot-indent', 'dot-sucess', 'dot-error'],
    };
  },
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    showForm: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    comment: {
      required,
      minLength: minLength(4),
    },
  },
  computed: {
    commentList() {
      return _.orderBy(this.comments, ['create_at'], ['desc']);
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.comment.$error) {
        this.$emit('addComment', this.comment);
        this.comment = '';
        this.$v.comment.$reset();
      }
    },
  },
};
</script>
<style lang="scss">
.comment-height{
 height: 180px;
 overflow: scroll;
}
.makeTop{
  z-index: 99999;
  position: relative;
}
</style>
